<div class="admin-container">
  <div class="card border-0 p-3">
    <app-investments-readonly-table
      [investments]="investments()"
      [loading]="isLoading()"
      [titleKey]="'admin.sideNav.projects.investments'"
      [actionsEnabled]="true"
      (acceptClicked)="acceptInvestment($event)"
      (rejectClicked)="rejectInvestment($event)"
      (approveClicked)="approveInvestment($event)"
    ></app-investments-readonly-table>
  </div>
</div>
